export default __webpack_public_path__ + "static/6668-bdb8e2eabd387ce15ce391c2371fa444.jpg";